import React from 'react';
import { scoreColor } from '../../lib/healthAnalysis';

/**
 * Sub-score bar card (Metabolic, Cardiovascular, Diabetes, Obesity, Fitness).
 */
const ScoreBarCard = ({ label, score, icon: Icon, testId }) => {
  const meta = scoreColor(score);
  const pct = score == null ? 0 : Math.max(0, Math.min(100, score));

  return (
    <div className="bg-slate-900/60 backdrop-blur-sm border border-slate-800 rounded-2xl p-4 sm:p-5" data-testid={testId}>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          {Icon && <Icon className={`w-4 h-4 ${meta.text}`} aria-hidden="true" />}
          <span className="text-slate-300 text-sm font-medium">{label}</span>
        </div>
        <span className={`text-lg sm:text-xl font-bold ${meta.text} tabular-nums`}>
          {score == null ? '-' : score}
        </span>
      </div>
      <div className="h-2 rounded-full bg-slate-800 overflow-hidden">
        <div
          className={`h-full rounded-full bg-gradient-to-r ${meta.from} ${meta.to} transition-all duration-1000 ease-out`}
          style={{ width: score == null ? '0%' : `${pct}%` }}
        ></div>
      </div>
      <p className={`text-xs mt-2 ${meta.text}`}>{meta.label}</p>
    </div>
  );
};

export default ScoreBarCard;
